module.exports = __webpack_public_path__ + "img/3_market_disapproval.15dcd2cb.svg";